exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".price-demo[data-v-1e8ac301]{width:50%;margin-left:10px;margin-right:10px;background-size:auto 112%}.price-demo[data-v-1e8ac301]:after{content:\"\";display:block;padding-bottom:100%}.price-demo.left[data-v-1e8ac301]{background-position:0}.price-demo.right[data-v-1e8ac301]{background-position:100%}", ""]);

// exports
